import ActionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'deleteQuestion',
  props: ['templateid', 'subGrupo', '', 'orientacao', 'cabecalho', 'assinatura'],
  components: {},
  mixins: [ActionsForm],
  data () {
    return {
      OrientacaoId: null
    }
  },
  mounted () {

  },
  watch: {
  },
  methods: {
    popUptAdd () {
      this.OrientacaoId = null
      this.$refs['deleteQuestion'].show()
    },
    popUptOrientacao (value) {
      this.OrientacaoId = value
      this.$refs['deleteQuestion'].show()
    },
    fecharPopUptAdd () {
      this.OrientacaoId = null
      this.$refs['deleteQuestion'].hide()
    },
    deleteItem () {
      this.$emit('deleteItensSubGrupo', true)
      this.fecharPopUptAdd()
    },
    deleteItemOrientacao () {
      var itemExclusao = {
        templateOrientacaoId: this.OrientacaoId,
        Excluir: true
      }
      this.$emit('deleteOrientacao', itemExclusao)
      this.fecharPopUptAdd()
    },
    deleteOrientacao () {
      this.$emit('removerOrientacaoDaTableEdicoes', true)
      this.fecharPopUptAdd()
    },
    deleteCabecalho () {
      this.$emit('removerDaTableEdicoes', true)
      this.fecharPopUptAdd()
    },
    deleteAssinatura () {
      this.$emit('removerAssinaturaDaTableEdicoes', true)
      this.fecharPopUptAdd()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/deleteQuestion/deleteQuestion.js